'use strict';

exports.__esModule = true;

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _profileDetails = require('./profile-details');

var _profileDetails2 = _interopRequireDefault(_profileDetails);

var _coreRightSection = require('./core-right-section');

var _coreRightSection2 = _interopRequireDefault(_coreRightSection);

var _nonCoreRightSection = require('./non-core-right-section');

var _nonCoreRightSection2 = _interopRequireDefault(_nonCoreRightSection);

var _helpers = require('../../../../src/client/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResult = function SearchResult(props) {
    var _extends2;

    var query = {
        hospitalList: props.selectedHospitalListId,
        network: props.searchedNetwork
    };
    var linkToProfile = (0, _helpers.getLink)(props.profileUrl, query);

    var searchType = props.searchType.toLowerCase();

    var treatmentParamName = searchType.includes('healthcheck') ? 'selectedHealthCheck' : searchType.includes('scan') ? 'selectedScan' : '';
    var treatmentParamValue = props.bookingType && props.bookingType.id && encodeURIComponent(props.bookingType.id) || '';
    var treatmentQuery = (0, _extends4.default)({}, query, (_extends2 = {}, _extends2[treatmentParamName] = treatmentParamValue, _extends2));
    var linkToProfileTreatment = (0, _helpers.getLink)(props.profileUrl, treatmentQuery);

    var showBadge = props.isCore || props.videoConsultation;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.searchResult, onMouseOver: props.onHover },
        _react2.default.createElement(
            _reactRouter.Link,
            {
                to: linkToProfileTreatment,
                className: [_style2.default.arrowRight, props.profileType === 'specialist' ? _style2.default.arrowRightSpecialist : _style2.default.arrowRightPractice, showBadge ? _style2.default.arrowRightBadge : ''].join(' '),
                onlyActiveOnIndex: false
            },
            _react2.default.createElement('i', { className: 'ion-chevron-right' })
        ),
        _react2.default.createElement(_profileDetails2.default, props),
        _react2.default.createElement(
            'div',
            { className: 'hidden-xs col-sm-6 col-md-5 ' + _style2.default.booking + ' ' + (!props.isCore && _style2.default.bookingNonCore || '') },

            // always show bmi slots
            (props.isCore || props.isBmi || props.isRamsay || props.isSpire || props.isNuffield) && _react2.default.createElement(_coreRightSection2.default, {
                availabilities: props.availabilities,
                nextAvailableAt: props.nextAvailableAt,
                availableFrom: props.availableFrom,
                hasBookings: props.hasBookings || props.isBmi || props.isRamsay || props.isSpire || props.isNuffield //always show bmi slots
                , profileUrl: linkToProfile
            }) || _react2.default.createElement(_nonCoreRightSection2.default, {
                availabilities: props.availabilities,
                hasBookings: props.hasBookings,
                profileUrl: linkToProfile
            })
        )
    );
};

SearchResult.propTypes = {
    peerRecommendations: require('react').PropTypes.any,
    hasBookings: require('react').PropTypes.any,
    availabilities: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
    subspecialties: require('react').PropTypes.arrayOf(require('react').PropTypes.any),
    specialty: require('react').PropTypes.any,
    specialtyIcon: require('react').PropTypes.any,
    profileName: require('react').PropTypes.any,
    averageRating: require('react').PropTypes.any,
    distance: require('react').PropTypes.any,
    profileImage: require('react').PropTypes.any,
    profileUrl: require('react').PropTypes.any,
    onHover: require('react').PropTypes.func,
    profileType: require('react').PropTypes.any,
    priceFrom: require('react').PropTypes.any,
    bookingType: require('react').PropTypes.any,
    availableFrom: require('react').PropTypes.object,
    selectedKeyword: require('react').PropTypes.any,
    searchType: require('react').PropTypes.any,
    hasRequestAppointment: require('react').PropTypes.any,
    isCore: require('react').PropTypes.any,
    isAHG: require('react').PropTypes.any,
    isBmi: require('react').PropTypes.any,
    isRamsay: require('react').PropTypes.any,
    isSpire: require('react').PropTypes.any,
    isNuffield: require('react').PropTypes.any,
    relatedPracticeName: require('react').PropTypes.any.isRequired,
    videoConsultation: require('react').PropTypes.bool.isRequired,
    selectedHospitalListId: require('react').PropTypes.number,
    networks: require('react').PropTypes.arrayOf(require('react').PropTypes.string).isRequired
};
SearchResult.defaultProps = {
    peerRecommendations: 0,
    hasBookings: false,
    availabilities: [],
    subspecialties: [],
    specialty: '',
    specialtyIcon: '',
    profileName: '',
    averageRating: 0,
    profileImage: '',
    profileUrl: '',
    onHover: function onHover() {},
    profileType: ''
};

SearchResult.displayName = 'SearchResult';
exports.default = SearchResult;


// WEBPACK FOOTER //
// ./components/search-results/lib/components/search-result.js